import Video from '../../form-elements/Video';
import { StoreConfigWidgetProps } from '../../types/store-config-widget';

function VideoWidget(props: StoreConfigWidgetProps) {
  return (
    <Video
      placeholder={props.placeholder}
      value={props.value}
      onChange={props.onChange}
      onFocus={props.onFocus}
      id={props.id}
    />
  );
}

export default VideoWidget;
